// 针对不同的状态禁止表格
export default {
  props: {
    detailPageData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      editConfig: { trigger: 'click', mode: 'row' },
      isShowVariablePriceIcon: false,
      currentDisabledFiledList: [], // 当前状态表格中禁用字段
    };
  },
  watch: {
    detailPageData: {
      handler(val) {
        if (val?.contractStatus) {
          console.log(val?.contractStatus, '监听当前状态');
          // TODO 可以删除等BA确认
          this.disabledBusinessChangeUnitPrice = val?.contractStatus == 'ZT03' ? false : true;
          // this.editConfig = {};
          // TODO 这块需求未全面确定，先一个状态一个状态判断
          const currentContractStatus = val?.contractStatus; // 'ZT021';
          if (currentContractStatus == 'ZT02') {
            // 审批中
            this.editConfig = {};
            this.isHiddenTopBtn = true;
          } else if (currentContractStatus == 'ZT03') {
            // 已生效
            this.editConfig = {};
            this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
            this.isHiddenTopBtn = true;
          } else if (currentContractStatus == 'ZT07') {
            // 已关闭状态表格不能编辑按钮没有
            this.editConfig = {};
            this.isHiddenTopBtn = true;
          } else if (currentContractStatus == 'ZT021') {
            // 修订审批中
            this.editConfig = {};
            this.isShowVariablePriceIcon = true;
            this.isHiddenTopBtn = true;
          } else if (currentContractStatus == 'ZT021') {
            // 审批修订中
            this.editConfig = {};
            this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
            this.isHiddenTopBtn = true;
          } else if (currentContractStatus == 'ZT025') {
            // 删除审批中
            this.editConfig = {};
            this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
            this.isHiddenTopBtn = true;
          } else if (currentContractStatus == 'ZT024') {
            // 生效审批中
            this.editConfig = {};
            this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
            this.isHiddenTopBtn = true;
          } else if (currentContractStatus == 'ZT022') {
            // 撤回审批中
            this.editConfig = {};
            this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
            this.isHiddenTopBtn = true;
          } else if (currentContractStatus == 'ZT023') {
            // 关闭审批中
            // 撤回审批中
            this.editConfig = {};
            this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
            this.isHiddenTopBtn = true;
          } else if (currentContractStatus == 'ZT061') {
            // 修订中,部分控件要禁止
            this.currentDisabledFiledList = [
              'materialType',
              'productQuantity2',
              'isFixedPrice',
              'priceConfirmDate',
              'priceIdentity',
              'variablePrice',
              'businessChangeUnitPrice',
              'shipmentPlace',
              'destination',
            ];
          } else if (currentContractStatus == 'ZT051') {
            // 修改已驳回,部分控件要禁止
            this.currentDisabledFiledList = [
              'materialType',
              'productQuantity2',
              'isFixedPrice',
              'priceConfirmDate',
              'priceIdentity',
              'variablePrice',
              'businessChangeUnitPrice',
              'shipmentPlace',
              'destination',
            ];
          } else {
            console.log('等待处理');
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
